import { logoStyles as styles } from "@insite/content-library/Widgets/Basic/Logo";
import { mediaQueriesBP } from "@tggstore/Utilities/variables";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        ${styles.wrapper?.css}

        ${mediaQueriesBP.maxMD} {
            display: flex;
            justify-content: center;
            max-width: 100%;
            max-height: 100%;
        }
    `,
};
